/**
 * @generated SignedSource<<e5ec179ade5357011bcd4531f780f663>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type IntegrationType = "AWS" | "BITBUCKET" | "BUILDKITE" | "CAPABILITIES" | "CLOUDWATCH" | "CONFLUENCE" | "CURSOR" | "DATADOG" | "DEVIN" | "DISCORD" | "ELASTICSEARCH" | "FIREHYDRANT" | "GCP" | "GCP_CLOUD_MONITORING" | "GITHUB" | "GITLAB" | "GRAFANA_CLOUD" | "INCIDENT_IO" | "JIRA" | "LANGFUSE" | "LANGSMITH" | "LINEAR" | "NEW_RELIC" | "NOTION" | "OPENSEARCH" | "OPSGENIE" | "PAGERDUTY" | "PGANALYZE" | "POSTGRESQL" | "PROMETHEUS" | "ROLLBAR" | "ROOTLY" | "SENTRY" | "SLACK" | "SNOWFLAKE" | "SOCKET" | "TEMPORAL" | "%future added value";
export type ValidateIntegrationInput = {
  credentials: string;
  integrationId?: any | null | undefined;
  integrationType: IntegrationType;
};
export type PostgreSQLIntegrationFormValidateIntegrationMutation$variables = {
  input: ValidateIntegrationInput;
};
export type PostgreSQLIntegrationFormValidateIntegrationMutation$data = {
  readonly validateIntegration: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type PostgreSQLIntegrationFormValidateIntegrationMutation = {
  response: PostgreSQLIntegrationFormValidateIntegrationMutation$data;
  variables: PostgreSQLIntegrationFormValidateIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ValidateIntegrationPayload",
    "kind": "LinkedField",
    "name": "validateIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PostgreSQLIntegrationFormValidateIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PostgreSQLIntegrationFormValidateIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "63e0a75ca86540315d73c0598a6aac49",
    "id": null,
    "metadata": {},
    "name": "PostgreSQLIntegrationFormValidateIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation PostgreSQLIntegrationFormValidateIntegrationMutation(\n  $input: ValidateIntegrationInput!\n) {\n  validateIntegration(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "46314a21cd652d43f9bb724001e4e1b4";

export default node;
